// The wrong-Open scream's monster: the Knocker most of the time, now and then one of its stand-ins, the eyes, the moth, the set
// or the spider (art/aseprite/src/knocker_skins.lua). Art only, by seed only, and seen only after the verdict, so it can't give
// anyone away; nothing is paid for it and it changes no points.
export const FAILS = ['eyes', 'moth', 'set', 'spider'];

// share of wrong Opens that stay the Knocker, the main answer
export const KNOCKER_SHARE = 0.6;

const fmix = h => { h >>>= 0; h ^= h >>> 16; h = Math.imul(h, 0x85ebca6b); h ^= h >>> 13; h = Math.imul(h, 0xc2b2ae35); h ^= h >>> 16; return h >>> 0; };
// the calm neighbours whose own monster screams at a wrong Open (game/regulars.js): Many-Eyes is the eyes, and so on
export const PAIRED = { 'n-eyes': 'eyes', 'n-moth': 'moth', 'n-set': 'set', 'n-spider': 'spider' };

// null: the Knocker
export function failOf(seed) {
  const h = fmix((seed ^ 0x7f4a7c15) >>> 0);
  if (h / 4294967296 < KNOCKER_SHARE) return null;
  return FAILS[fmix(h ^ 0x9e3779b9) % FAILS.length];
}
